import { VALIDATE_TOKEN, LOGIN_FAILED } from '../action-types'
import api, { BE_API } from '../../common/api'
import { handleServerError } from '../../common/utils'

export const validateToken = token => async dispatch => {
  try {
    const res = await api.user.authenticate(token)
    BE_API.defaults.headers.Authorization = `Bearer: ${token}`
    return dispatch({ type: VALIDATE_TOKEN, payload: res.data })
  } catch (error) {
    handleServerError(error)
    // Without a user Auth would show its loader forever, which reads as the app still thinking.
    return dispatch({ type: LOGIN_FAILED })
  }
}